

interface ExclusiveContentProps {
  citation: string[] | any;
  onCitationClick?: (citation: string) => void;
}

function ExclusiveContentCitations({ citation, onCitationClick }: ExclusiveContentProps) {
  function onCitationClicked(citations: any): void {
    if (onCitationClick) {
      onCitationClick(citations);
    }
  }
  return (
    <div>
      <button
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          onCitationClicked(citation);
        }}
        className="cursor-pointer   text-left block link_text_color hover:underline"
      >
        {citation.title} <i> by {citation.author}</i>
      </button>
    </div>
  );
}

export default ExclusiveContentCitations;
